const useErrorMessage = () => {
  const getErrorMessage = (res) => {
    return res?.response?.data?.message || res?.message || "You Are Logout";
  };
  return {
    getErrorMessage,
  };
};
export default useErrorMessage;
